require('es6-promise').polyfill();

import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import users from './modules/users';
import settings from './modules/settings';
import shows from './modules/shows';
import search from './modules/search';
import layout from './modules/layout';
import cart from './modules/cart';
import episodes from './modules/episodes';
import notifications from './modules/notifications';
import clips from './modules/clips';

Vue.use(Vuex);

// eslint-disable-next-line
const strict = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
   modules: { auth, users, settings, shows, search, layout, cart, episodes, notifications, clips },
   strict
});
